import React from "react";
import HeroSection from "./HeroSection";
import ContactList from "./ContactList";
import Message from "./Message";

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ContactUs = ({setIsOpen}: Props) => {
  return (
    <div className="flex flex-col overflow-hidden mx-auto max-w-screen-2xl items-center justify-center">
      <HeroSection setIsOpen={setIsOpen} />
      <ContactList />
      <Message />
    </div>
  );
};

export default ContactUs;
